import api from './base-api';

interface ModelApiKey {
	id: string;
	key_prefix: string;
	label: string | null;
	created_date: string;
	last_used_at: string | null;
}

export interface GenerateKeyResponse {
	id: string;
	key: string;
	key_prefix: string;
	label: string | null;
	created_date: string;
}

const modelApiKeysApi = api.injectEndpoints({
	endpoints: (builder) => ({
		generateModelApiKey: builder.mutation<GenerateKeyResponse, { label?: string }>({
			query: (body) => ({ url: 'v1/keys', method: 'POST', body }),
			invalidatesTags: ['ModelApiKey'],
		}),
		updateModelApiKey: builder.mutation<ModelApiKey, { id: string; label: string }>({
			query: ({ id, label }) => ({ url: `v1/keys/${id}`, method: 'PATCH', body: { label } }),
			invalidatesTags: (_result, _error, { id }) => ['ModelApiKey', { type: 'ModelApiKey', id }],
		}),
	}),
});

export const { useGenerateModelApiKeyMutation, useUpdateModelApiKeyMutation } = modelApiKeysApi;
